import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from './ui/card';
import { FlaskConical, Settings, Cpu } from 'lucide-react';

const InovasyonSection = () => {
  const { t } = useLanguage();

  const innovations = [
    {
      key: 'arGe',
      contentKey: 'arGeContent',
      icon: <FlaskConical className="w-10 h-10" />,
      color: 'text-violet-600',
      bgColor: 'bg-violet-100',
    },
    {
      key: 'surecIyilestirme',
      contentKey: 'surecContent',
      icon: <Settings className="w-10 h-10" />,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
    },
    {
      key: 'teknoloji',
      contentKey: 'teknolojiContent',
      icon: <Cpu className="w-10 h-10" />,
      color: 'text-teal-600',
      bgColor: 'bg-teal-100',
    },
  ];

  return (
    <section id="inovasyon" className="py-20 bg-gradient-to-br from-gray-900 to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            {t('innovation.title')}
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto"></div>
        </div>

        {/* Innovations Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {innovations.map((item) => (
            <Card
              key={item.key}
              className="border-none bg-white/10 backdrop-blur-md hover:bg-white/20 transition-all group"
            >
              <CardContent className="p-8 text-center">
                <div
                  className={`w-20 h-20 mx-auto mb-6 rounded-2xl ${item.bgColor} flex items-center justify-center ${item.color} group-hover:scale-110 transition-transform`}
                >
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-4">
                  {t(`innovation.${item.key}`)}
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  {t(`innovation.${item.contentKey}`)}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InovasyonSection;
